/**
 * The control a field jump should focus, in document order. A field opts out of
 * the native-element rules by marking an element `data-field-focus-target`: a
 * dropzone keeps its real `input[type="file"]` in a visually hidden 1px box and
 * puts the keyboard affordance (focus ring, Enter to open the picker) on its
 * wrapper, so focusing the input would strand the reader on nothing they can see.
 */
const FIELD_CONTROL_SELECTOR = [
  '[data-field-focus-target]',
  'input:not([type="file"])',
  'textarea',
  'button',
].join(', ');

/**
 * Moves focus to the control inside `field` the reader is meant to answer with.
 * Never scrolls — callers animate the scroll themselves, and a second scroll
 * from the browser's focus handling would fight that animation.
 */
export function focusFieldControl(field: HTMLElement | null | undefined): void {
  field?.querySelector<HTMLElement>(FIELD_CONTROL_SELECTOR)?.focus({ preventScroll: true });
}
